export const ColorsList = {
    orange: "#ff993f",
    mid_orange: "#E48638",
    dark_orange: '#C37631',
    red: '#FF0000',
    red_google_marker_light: '#d73f34',
    red_google_marker_dark: '#752622',
    red_pastel: "#d25757",
    red_vivid: '#F12D28',
    yellow: '#dddd7d',
    green: '#4caf50',
    green_olive: '#337200',
    skyblue: '#2196f3',
    navy_blue: '#3c4a66',
    dark_blue: '#113378',
    dark_smartway: '#2C3E50',
    white: '#ffffff',
    black: '#000000',
    purple:  '#A020F0',
    light_purple: '#d8b3ff',
    light_gray: '#e3e3e3',
    gray: '#808080',
    gold: '#e69138',
    light_red: '#ffcccc',
    light_red_second: '#b83029',
    dark_red: '#a80101',
    light_brown: "#a8b875"
}